import React from 'react';

const APIProgram = () => {
    const handleClick = () => {
        window.open('https://www.charmhealth.com/resources/fhir/index.html', '_blank');
    };

    return (
        <div className="w-full flex flex-col px-12 xl:px-36 pb-12">
            <img src="https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/Webinars+(1).png" alt="Webinar Image" className="mt-4 w-full h-fit object-cover xl:hidden">
            </img>


            <p className="mt-4 font-proximanova text-[18px] text-[#505050] mb-0">CharmHealth API Program offers comprehensive set of REST APIs, that allows other medical applications and devices to interact with Charm EHR seamlessly. If you are interested in building or integrating your application with CharmHealth, please fill in the form below. We will get back to you soon with instructions to get started with CharmHealth API.</p>

            <div className="w-full mt-4 flex flex-col xl:grid xl:grid-cols-2 xl:gap-4 2xl:mt-12">
                <div className="w-full flex flex-col h-[600px] m-0">
                    <iframe src="https://creator.zohopublic.com/medicalmine/var/form-embed/API_Access_Request_Form/A9U7Pj1eONvajHDzqnJuvqdTDRaXSBjTbaXpGfgVHrukbExas4QKf4eWm6dktUzEsJNKgBCRd6d2Vtk732YbC3SHf05VpGp3XYmT" scrolling="auto" width="100%" height="600px" frameborder="0"></iframe>
                </div>

                <div className="w-full flex flex-col mx-auto">
                    <img src="https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/Webinars+(1).png" alt="Webinar Image" className="w-full h-fit object-cover hidden xl:block">
                    </img>

                    <button className="mt-4 w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4 mx-auto" onClick={handleClick} >FHIR API DOCUMENTATION</button>

                    <p className="mt-6 font-proximanova text-[18px] text-[#505050] font-[600] mb-0">Steps to use CharmHealth API</p>
                    <p className="mt-2 font-proximanova text-[18px] text-[#505050] mb-0">1. Fill out the "API Access Request" form on this page</p>
                    <p className="mt-2 font-proximanova text-[18px] text-[#505050] mb-0">2. We will review and send the instructions on using the API</p>
                    <p className="mt-2 font-proximanova text-[18px] text-[#505050] mb-0">3. Access API documentation and build your application</p>
                </div>
            </div>
        </div>
    );
}

export default APIProgram;